import styles from "./TermsCondition.module.css";

export default function IndiaTermsContent() {
  return (
    <>
      <h3 className={styles.nextTitle}>Terms &amp; Conditions</h3>
      <p className={styles.nextParagraph}>
        These Terms and Conditions (&ldquo;Terms&rdquo;) govern the use of
        travel-related services provided by Blueberry Travel India Private
        Limited, operating under the brand name Next Holidays (&ldquo;Company&rdquo;,
        &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;).
        <br />
        By accessing our website or booking any travel-related service through
        Next Holidays, you acknowledge that you have read, understood, and agreed
        to be bound by these Terms and Conditions.
        <br />
        These Terms apply to all bookings and services offered through our
        website, including but not limited to holiday packages, flight bookings,
        hotel reservations, visa assistance, transfers, sightseeing, and other
        allied travel services.
      </p>

      <h4 className={styles.nextSubheading}>1. Definitions</h4>
      <p className={styles.nextParagraph}>
        &ldquo;Customer&rdquo;, &ldquo;You&rdquo;, &ldquo;Your&rdquo; shall mean
        any individual or entity accessing our website or availing our services.
        <br />
        <br />
        &ldquo;Services&rdquo; shall mean all travel-related products and services
        offered by Next Holidays, including but not limited to domestic and
        international holiday packages, flights, hotel bookings, transportation,
        visa assistance, sightseeing, and related travel services.
        <br />
        <br />
        &ldquo;Supplier/Partner&rdquo; shall mean third-party service providers
        including airlines, hotels, transport operators, visa processing agencies,
        insurance providers, and other vendors associated with service delivery.
        <br />
        <br />
        &ldquo;Booking&rdquo; shall mean any confirmed reservation made through
        our website, sales team, or authorized representatives.
        <br />
        <br />
        &ldquo;Website&rdquo; shall mean the official Next Holidays digital
        platforms operated by Blueberry Travel India Private Limited.
      </p>

      <h4 className={styles.nextSubheading}>2. Use of Services</h4>
      <p className={styles.nextParagraph}>
        Customers must be at least 18 years of age and legally competent to make
        bookings through our website. By using our services, you agree to provide
        accurate and complete information at the time of booking. Next Holidays
        shall not be responsible for any loss, delay, cancellation, or additional
        charges arising due to incorrect or incomplete information provided by the
        customer. Our services may only be used for lawful purposes, and any
        fraudulent, unauthorized, or misuse of the website or services is strictly
        prohibited. We reserve the right to refuse or cancel any booking in case
        of suspected misuse, fraud, or violation of these Terms.
      </p>

      <h4 className={styles.nextSubheading}>3. Pricing</h4>
      <p className={styles.nextParagraph}>
        All prices displayed on our website are subject to availability and may
        change without prior notice due to fluctuations in airfare, hotel tariffs,
        currency exchange rates, taxes, supplier charges, or other operational
        factors. Unless specifically mentioned, prices do not include visa fees,
        travel insurance, meals, personal expenses, optional activities, or any
        additional services not expressly stated in the booking confirmation. The
        final price shall be confirmed only upon successful payment and booking
        confirmation by Next Holidays.
      </p>

      <h4 className={styles.nextSubheading}>4. Methods of Payment</h4>
      <p className={styles.nextParagraph}>
        Payments for bookings must be made through the payment methods authorized
        by Next Holidays, including secure online payment gateways, bank transfers,
        or other approved modes. Booking confirmation is subject to successful
        receipt of payment. In cases where partial payment is accepted, the
        balance amount must be paid within the specified timeline, failing which
        the booking may be cancelled without prior notice and applicable
        cancellation charges may apply.
      </p>

      <h4 className={styles.nextSubheading}>5. Confirmation of Payment</h4>
      <p className={styles.nextParagraph}>
        Once the payment is successfully received, Next Holidays will issue a
        booking confirmation via email or other electronic means. This confirmation
        will serve as proof of booking and must be presented to avail the booked
        services. Customers are responsible for reviewing all booking details
        mentioned in the confirmation and must immediately report any discrepancies
        to the Company.
      </p>

      <h4 className={styles.nextSubheading}>
        6. Cancellation, No Display Policy &amp; Refund Processing
      </h4>
      <div className={styles.nestedSection}>
        <p className={`${styles.nextParagraph} ${styles.nextSubheading}`}>
          6.1 Cancellation
        </p>
        <p>
          Cancellation of bookings is subject to the specific terms and conditions
          applicable to each service and supplier at the time of booking. In case
          of cancellation of a package or combo booking, revised charges shall
          apply based on the individual services utilised or retained. Certain
          components such as visa fees, service charges, and third-party/
          non-refundable services may not be refunded once confirmed and booked.
        </p>

        <p className={`${styles.nextParagraph} ${styles.nextSubheading}`}>
          6.2 Refund Process Time
        </p>
        <p>
          Eligible refunds, if any, shall be processed within 10–15 working days
          from the date of cancellation confirmation, subject to receipt of
          refunds from the respective suppliers. Refunds will be made to the
          original mode of payment, after deducting applicable cancellation
          charges, service fees, or non-refundable components.
        </p>

        <p className={`${styles.nextParagraph} ${styles.nextSubheading}`}>
          6.3 No Show
        </p>
        <p>
          In the event of a no-show or failure to utilise confirmed services, no
          refund shall be applicable under any circumstances. Rescheduling of
          confirmed bookings, if permitted, shall be strictly subject to
          availability and supplier policies, and may attract additional charges.
        </p>
      </div>

      <h4 className={styles.nextSubheading}>7. Cancellation Procedures</h4>
      <p className={styles.nextParagraph}>
        All cancellation requests must be made in writing via email or through our
        official communication channels. Upon receipt of a cancellation request,
        Next Holidays will acknowledge the same and inform the applicable
        cancellation charges as per the service and supplier terms. Cancellation
        shall be considered valid only once confirmed by the Company in writing.
        The Company shall not be responsible for any cancellation request that is
        not received or not confirmed by us.
      </p>

      <h4 className={styles.nextSubheading}>8. Itinerary Amendments</h4>
      <p className={styles.nextParagraph}>
        Itineraries and services are subject to change due to operational
        requirements, supplier constraints, weather conditions, airline schedule
        changes, local authority regulations, or force majeure events. In such
        cases, we will make reasonable efforts to provide suitable alternatives of
        similar value, subject to availability. Next Holidays reserves the right
        to make minor modifications to itineraries at any time without liability
        or compensation.
      </p>

      <h4 className={styles.nextSubheading}>9. Tour Documents</h4>
      <p className={styles.nextParagraph}>
        It is the sole responsibility of the Customer to ensure they carry all
        valid travel documents required for their journey, including passports,
        visas, identity proofs, and any other documents mandated by authorities
        or suppliers. Failure to carry valid documents may result in denial of
        services without any refund. Customers are advised to verify visa, entry,
        health, and travel requirements with the relevant consulates or
        authorities prior to travel, as these requirements may change without prior
        notice.
      </p>

      <h4 className={styles.nextSubheading}>10. Website Usage Regulations</h4>
      <p className={styles.nextParagraph}>
        All content available on this website, including text, images, graphics,
        logos, branding, and travel information, is the exclusive property of
        Blueberry Travel India Private Limited operating under the brand name Next
        Holidays. Users are strictly prohibited from copying, reproducing,
        distributing, or using any content for commercial or unauthorized
        purposes without prior written consent. Any misuse of website content may
        result in legal action.
      </p>

      <h4 className={styles.nextSubheading}>11. Delivery &amp; transport coverage</h4>
      <p className={styles.nextParagraph}>
        Next Holidays shall not provide any services to individuals or entities
        located in countries or regions subject to sanctions or restrictions under
        applicable laws, including OFAC or equivalent regulatory bodies. All
        services are provided in compliance with the laws of India and applicable
        international regulations. Certain services may also be subject to
        additional regulatory, airline, hotel, or supplier restrictions, which
        shall apply as binding conditions of booking.
      </p>

      <h4 className={styles.nextSubheading}>12. Governing Law and Jurisdiction</h4>
      <p className={styles.nextParagraph}>
        These Terms and Conditions shall be governed by and construed in accordance
        with the laws of India. Any dispute, claim, or matter arising out of or
        in connection with the use of this website or services shall be subject to
        the exclusive jurisdiction of the courts at Jaipur, Rajasthan, India.
      </p>

      <h4 className={styles.nextSubheading}>13. Disclaimer</h4>
      <p className={styles.nextParagraph}>
        <b>Travel at Your Own Risk:</b> The information provided on this website
        is for general informational purposes only. While we make reasonable
        efforts to ensure accuracy, we do not guarantee completeness, reliability,
        or suitability of any information, services, itineraries, pricing, or
        related content. Any reliance placed on such information is strictly at
        the customer&apos;s own risk.
      </p>
      <p className={styles.nextParagraph}>
        <b>Changes to Itineraries and Prices:</b> Prices, itineraries, and
        availability of travel services are subject to change without prior
        notice due to supplier updates, operational requirements, currency
        fluctuations, taxes, or other external factors. Next Holidays shall not be
        liable for any changes, delays, cancellations, or service disruptions
        caused by third-party service providers.
      </p>
      <p className={styles.nextParagraph}>
        <b>Third-Party Links:</b> Our website may contain links to external
        websites operated by third parties. We do not control or endorse such
        websites and are not responsible for their content, privacy practices, or
        policies. Customers are advised to review the terms of such third-party
        websites before use.
      </p>
      <p className={styles.nextParagraph}>
        <b>Third Party Disclosure:</b> We may share necessary customer information
        with trusted third-party suppliers, including airlines, hotels, transport
        providers, visa processors, and other service partners, strictly for the
        purpose of fulfilling bookings and services. We may also share information
        within affiliated entities where required for operational purposes.
      </p>
      <p className={styles.nextParagraph}>
        <b>Access, Accuracy and Security:</b> We take reasonable measures to ensure
        that customer data is accurate, secure, and updated. Customers may
        request correction or deletion of their personal information by contacting
        us. However, we shall not be responsible for unauthorized access arising
        beyond reasonable security controls.
      </p>
      <p className={styles.nextParagraph}>
        <b>Health and Safety:</b> Customers are advised to consult relevant
        professionals before travel. We do not provide medical, legal, or
        professional advice. Customers must comply with all health, safety, and
        local regulations applicable at their travel destination.
      </p>
      <p className={styles.nextParagraph}>
        <b>Copyright Notice:</b> All content on this website, including text,
        images, graphics, logos, and design, is the property of Blueberry Travel
        India Private Limited operating under the brand name Next Holidays and is
        protected under applicable copyright laws. Unauthorized use, reproduction,
        or distribution is strictly prohibited.
      </p>
      <p className={styles.nextParagraph}>
        <b>Beware of Phishing Scams Stay Vigilant:</b> Phishing involves
        fraudulent attempts to obtain sensitive information such as passwords or
        payment details. Customers are advised to verify sender details, avoid
        sharing personal information, and only rely on official communication
        channels.
      </p>
      <p className={styles.nextSubheading}>How to Protect Yourself:</p>
      <p className={styles.nextParagraph}>
        <b>Verify the Source:</b> Always verify the source of any communication
        claiming to be from Next Holidays by checking the official email domain
        and website URL. Be cautious of unsolicited emails, messages, or links that
        create urgency or request personal, financial, or login information. We
        will never ask for sensitive details such as passwords or payment
        information through unsecured channels. Customers are advised not to click
        on suspicious links or share personal details with unknown sources. In case
        of doubt, please contact us directly through our official communication
        channels before taking any action.
      </p>
      <p className={styles.nextParagraph}>
        <b>Reporting Phishing:</b> Any suspicious communication should be reported
        immediately to the official support email at feedback.ind@nextholidays.com
        for necessary action.
      </p>

      <h4 className={styles.nextSubheading}>14. Caution</h4>
      <p className={styles.nextParagraph}>
        Beware of Fake Promotions or Offers: Customers are strongly advised not to
        engage with or rely on any unsolicited promotional emails, SMS, messages,
        or social media links requesting personal details, payments, or clicks on
        unknown links. All official communications from Next Holidays will only be
        sent through our verified domains: nextholidays.com or nextholidays.co.in.
        The Company shall not be liable for any loss, damage, or fraud arising
        from communications not originating from our official channels or
        authorized representatives.
      </p>

      <h4 className={styles.nextSubheading}>15. Tour Coverage</h4>
      <p className={styles.nextParagraph}>
        Next Holidays shall not be liable for any loss, damage, injury, accident,
        illness, delay, or inconvenience arising during the course of travel,
        including but not limited to acts or omissions of third-party service
        providers such as airlines, hotels, transport operators, or local vendors.
        All services are arranged on a facilitation basis, and responsibility for
        actual service delivery rests with the respective suppliers. Customers are
        advised to take appropriate travel insurance to cover unforeseen risks,
        including medical emergencies, trip cancellations, or loss of baggage.
      </p>

      <p className={styles.nextParagraph}>
        Stay safe and enjoy your travels with Next Holidays.
      </p>

      <h4 className={styles.nextSubheading}>
        16. Payment Gateway, Chargeback &amp; Transaction Security
      </h4>
      <p className={styles.nextParagraph}>
        All payments made through our website are processed via secure third-party
        payment gateways. Next Holidays does not store complete card or banking
        details of customers and shall not be responsible for any failure, delay,
        or technical error arising during online transactions. In case of payment
        disputes or chargebacks initiated by the customer after booking
        confirmation, the Company reserves the right to provide all booking and
        service records to the concerned financial institution and recover any
        losses, cancellation charges, or administrative costs incurred due to
        such disputes. Any fraudulent or unauthorized transactions may result in
        cancellation of services without prior notice.
      </p>

      <h4 className={styles.nextSubheading}>17. GST, TCS &amp; Taxation</h4>
      <p className={styles.nextParagraph}>
        All applicable government taxes including GST, TCS, or any other statutory
        levies shall be charged as per prevailing laws at the time of booking. Any
        change in tax structure imposed by the government after confirmation of
        booking may be additionally chargeable to the customer. The Company shall
        issue tax invoices as per applicable legal requirements, and customers are
        responsible for ensuring accurate billing details at the time of booking.
        Next Holidays shall not be held liable for any tax-related implications
        arising due to incorrect information provided by the customer.
      </p>

      <h4 className={styles.nextSubheading}>
        18. Quotation Validity &amp; Contract Formation
      </h4>
      <p className={styles.nextParagraph}>
        All quotations provided by Next Holidays are subject to availability and
        are valid only for the period mentioned in the quotation or, if not
        specified, for a limited duration based on supplier pricing and
        availability. A booking shall be considered confirmed only upon receipt of
        full or agreed partial payment and issuance of a booking confirmation by
        Next Holidays. Until such confirmation is issued, no quotation shall be
        treated as a binding contract.
      </p>

      <h4 className={styles.nextSubheading}>
        19. Visa Services &amp; Rejection Disclaimer
      </h4>
      <p className={styles.nextParagraph}>
        Visa approval or rejection is solely at the discretion of the respective
        embassy, consulate, or immigration authority. Next Holidays acts only as a
        facilitator for visa processing and does not guarantee approval under any
        circumstances. Visa fees, service charges, and related costs are
        non-refundable in case of rejection, delay, or denial. The Company shall
        not be held responsible for any loss arising due to visa rejection or
        delay.
      </p>

      <h4 className={styles.nextSubheading}>20. Communication Consent</h4>
      <p className={styles.nextParagraph}>
        By using our services, the Customer consents to receive communication from
        Next Holidays through email, SMS, WhatsApp, or other electronic means
        regarding bookings, updates, offers, and service-related information. The
        Customer may opt out of promotional communications at any time, subject to
        operational and booking-related communications remaining unaffected.
      </p>
    </>
  );
}
